<template>
  <div>
    <!-- DESKTOP -->
    <v-app-bar
      id="avecor-toolbar"
      clipped-left
      clipped-right
      fixed
      :flat="isTopBarFlat"
      app
      height="35"
      pa-0
      ma-0
      style="overflow-x:scroll;overflow-y:hidden;"
      dense
      
    >
      <img src="https://storage.googleapis.com/cdn.avecor.fi/avecor-logo-no-slogan-200x57.png" alt="Avecor Logo" style="max-width:200px; height:25px; position:relative; left:-5px;top:-3px;" >
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer" color="#000"></v-app-bar-nav-icon>
      <v-toolbar-items class="hidden-sm-and-down">
        <span v-for="item in menuItems" :key="item.id">
          <v-btn
            v-if="item.id === 'signout'"
            class="nav-button"
            style="font-size:10px !important; font-weight:550;padding: 0 5px; letter-spacing:0px;min-width:unset !important;"
            no-action
            :disabled="item.disabled ? true : false"
            @click="item.click ? item.click(item.id) : null"
            :key="item.id"
            :to="item.path ? item.path : null">
            <v-icon style="padding-right:4px" :size="10">{{ item.icon }}</v-icon>
            <span >{{ item.name }}</span>
          </v-btn>
          <v-btn
            v-else
            class="nav-button"
            :style="`font-size:10px !important; font-weight:550;padding: 0 5px; letter-spacing:0px;${selectedView === item.id ? 'color:#F26539 !important;' : ''}`"
            no-action
            :disabled="item.disabled ? true : false"
            @click="item.click ? item.click(item.id) : null"
            :key="item.id"
            :to="item.path ? item.path : null">
            <v-icon style="padding-right:4px" :size="10">{{ item.icon }}</v-icon>
            <span >{{ item.name }}</span>
          </v-btn>
        </span>
      </v-toolbar-items>
      <v-menu class="hidden-md-and-up">
        <!--<v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>-->
        <v-list>
          <v-list-tile v-for="item in menuItems" :key="'mobilemenu-'+item.id">
            <v-list-tile-content @click="item.click ? item.click(item.id) : null">
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>   
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- MOBILE -->
    <v-navigation-drawer
      v-model="drawer"
      right
      width="260"
      fixed
      style="margin-top:56px;z-index:100;background:#FFF;box-shadow:unset !important;-webkit-box-shadow:unset !important;"
      overlay-opacity="0"
    >
      <v-list
        nav
        dense
      >
        <div v-for="(item,i) in mobileMenuItems" :key="i+'-mobile'">
          <v-list-item>
            <v-list-item-icon><v-icon style="padding-right:6px" :size=menuIconSize>{{ item.icon }}</v-icon></v-list-item-icon>
            <v-list-item-title style="cursor:pointer;" @click="item.click ? item.click(item.id) : null">{{ item.name }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'

export default {
    data: () => ({
      drawer: false,
      autogrow:true,
      isTopBarFlat:true,
      clippedToolbar:true,
      selectedView:''
    }),
    mounted() {
      this.isWarehouse ? this.selectedView = this.warehouseView : null
      this.isOffice ? this.selectedView = this.officeView : null
      this.isSales ? this.selectedView = this.salesView : null
      this.isAdmin ? this.selectedView = this.adminView : null
    },
    computed: {
      ...mapFields([
        'settings.menuIconSize',
        'settings.isSales',
        'settings.isOffice',
        'settings.isWarehouse',
        'settings.isAdmin',
        'selectedView.officeView',
        'selectedView.salesView',
        'selectedView.clientView',
        'selectedView.warehouseView',
        'selectedView.adminView',
        'views.orders.selectedOrder.orderId',
        'settings',
        'user',
        'staff.staff'
      ]),
      disableReportView(){
        if(!this.user) return true
        if(!this.user.uid) return true
        if(this.staff[this.user.uid] && this.staff[this.user.uid].disableReportView) return true
        return false
      },
      disableOrdersView(){
        if(!this.user) return true
        if(!this.user.uid) return true
        if(this.staff[this.user.uid] && this.staff[this.user.uid].disableOrdersView) return true
        return false
      },
      mobileMenuItems () {
        var menu = []
        if (this.isOffice) {
          menu.push({ id: 'newOrder', path: '/', icon: 'fab fa-wpforms', name: "Uusi Tilaus", click:this.setView })
          menu.push({ id: 'orders', path: '/', icon: 'fas fa-file-invoice-dollar', name: "Tilaukset", click:this.setView, disabled:this.disableOrdersView })
          menu.push({ id: 'stock', path: '/', icon: 'fas fa-warehouse', name: "Varasto", click:this.setView })
          menu.push({ id: 'report', path: '/', icon: 'fas fa-chart-line', name: "Raportti", click:this.setView, disabled:this.disableReportView  })
          menu.push({ id: 'companies', path: '/', icon: 'fas fa-building', name: "Yritykset", click:this.setView })
          menu.push({ id: 'signout', path: '/', icon: 'fas fa-sign-out-alt', name: "Logout", click:this.userSignOut })
        } 
        else if (this.isSales) {
          menu.push({ id: 'newOrder', path: '/', icon: 'fab fa-wpforms', name: "Uusi Tilaus", click:this.setView })
          menu.push({ id: 'orders', path: '/', icon: 'fas fa-file-invoice-dollar', name: "Tilaukset", click:this.setView, disabled:this.disableOrdersView }) // 'I7RPIfMJIbYurRauvSR35yp9MJD2'
          //menu.push({ id: 'stock', path: '/', icon: 'fas fa-warehouse', name: "Varasto", click:this.setView })
          menu.push({ id: 'report', path: '/', icon: 'fas fa-chart-line', name: "Raportti", click:this.setView, disabled:this.disableReportView })
          menu.push({ id: 'companies', path: '/', icon: 'fas fa-building', name: "Yritykset", click:this.setView })
          menu.push({ id: 'signout', path: '/', icon: 'fas fa-sign-out-alt', name: "Logout", click:this.userSignOut })
        }
        else if (this.isWarehouse) {
          menu.push({ id: 'orders', path: '/', icon: 'fas fa-file-invoice-dollar', name: "Tilaukset", click:this.setView })
          menu.push({ id: 'stock', path: '/', icon: 'fas fa-warehouse', name: "Varasto", click:this.setView })
          menu.push({ id: 'products', path: '/', icon: 'fas fa-briefcase', name: "Tuotteet", click:this.setView })
          menu.push({ id: 'signout', path: '/', icon: 'fas fa-sign-out-alt', name: "Logout", click:this.userSignOut })
        }
        return menu
      },
      menuItems () {
        var menu = []
        var isAdmin = this.staff[this.user.uid] && this.staff[this.user.uid].isAdmin ? true : false
        var isOfficeUser = this.staff[this.user.uid] && this.staff[this.user.uid].role === 'office' ? true : false
        if (this.isOffice) {
          menu.push({ id: 'newOrder', path: '/', icon: 'fab fa-wpforms', name: "Uusi Tilaus", click:this.setView })
          menu.push({ id: 'weekReport', path: '/', icon: 'fas fa-file-alt', name: "Viikkoraportti", click:this.setView })
          //menu.push({ id: 'salesTips', path: '/', icon: 'far fa-lightbulb', name: "Myyntivinkit", click:this.setView })
          menu.push({ id: 'promotions', path: '/', icon: 'fas fa-envelope-open-text', name: "Tarjoukset", click:this.setView })
          menu.push({ id: 'margins', path: '/', icon: 'fas fa-euro-sign', name: "Katteet", click:this.setView })
          
          menu.push({ id: 'orders', path: '/', icon: 'fas fa-file-invoice-dollar', name: "Tilaukset", click:this.setView, disabled:this.disableOrdersView })
          menu.push({ id: 'stock', path: '/', icon: 'fas fa-warehouse', name: "Varasto", click:this.setView })
          menu.push({ id: 'notes', path: '/', icon: 'fas fa-sticky-note', name: "Informaatio", click:this.setView })
          menu.push({ id: 'shop', path: '/', icon: 'fas fa-shopping-cart', name: "Shop", click:this.setView })
          isAdmin || isOfficeUser ? menu.push({ id: 'prices', path: '/', icon: 'fas fa-money-check-alt', name: "Hinnasto", click:this.setView }) : '' //<font-awesome-icon icon="fa-solid fa-money-check-dollar" />
          menu.push({ id: 'report', path: '/', icon: 'fas fa-chart-line', name: "Raportti", click:this.setView, disabled:this.disableReportView })
          menu.push({ id: 'products', path: '/', icon: 'fas fa-briefcase', name: "Tuotteet", click:this.setView })
          menu.push({ id: 'partners', path: '/', icon: 'fas fa-archway', name: "Kumppanit", click:this.setView })
          //menu.push({ id: 'files', path: '/', icon: 'fas fa-archive', name: "Tiedostot", click:this.setView })
          menu.push({ id: 'companies', path: '/', icon: 'fas fa-building', name: "Yritykset", click:this.setView })
          menu.push({ id: 'staff', path: '/', icon: 'fas fa-users', name: "Henkilöstö", click:this.setView })
          menu.push({ id: 'development', path: '/', icon: 'fa-solid fa-code', name: "Kehitys", click:this.setView })
          
          //menu.push({ id: 'tags', path: '/', icon: 'fas fa-tags', name: "Tuotetagit", click:this.setView })
          menu.push({ id: 'signout', path: '/', icon: 'fas fa-sign-out-alt', name: "Logout", click:this.userSignOut })
        } 
        else if (this.isSales) {
          menu.push({ id: 'newOrder', path: '/', icon: 'fab fa-wpforms', name: "Uusi Tilaus", click:this.setView })
          if(this.user.uid !== undefined && this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].weekReportingRequired || this.user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2' || this.user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'))
            menu.push({ id: 'weekReport', path: '/', icon: 'fas fa-file-alt', name: "Viikkoraportti", click:this.setView })
          //if(this.user.uid !== undefined && this.staff[this.user.uid] !== undefined &&  this.staff[this.user.uid].promotionsAccess) 
          menu.push({ id: 'promotions', path: '/', icon: 'fas fa-envelope-open-text', name: "Tarjoukset", click:this.setView })
          menu.push({ id: 'margins', path: '/', icon: 'fas fa-euro-sign', name: "Katteet", click:this.setView })
          menu.push({ id: 'orders', path: '/', icon: 'fas fa-file-invoice-dollar', name: "Tilaukset", click:this.setView, disabled:this.disableOrdersView })
          menu.push({ id: 'stock', path: '/', icon: 'fas fa-warehouse', name: "Varasto", click:this.setView })
          menu.push({ id: 'notes', path: '/', icon: 'fas fa-sticky-note', name: "Informaatio", click:this.setView })
          menu.push({ id: 'report', path: '/', icon: 'fas fa-chart-line', name: "Raportti", click:this.setView, disabled:this.disableReportView })
          menu.push({ id: 'companies', path: '/', icon: 'fas fa-building', name: "Yritykset", click:this.setView })
          if(this.user.uid !== undefined && this.staff[this.user.uid] !== undefined &&  (this.staff[this.user.uid].productsAccess || this.staff[this.user.uid].isAdmin))
            menu.push({ id: 'products', path: '/', icon: 'fas fa-briefcase', name: "Tuotteet", click:this.setView })
          if(this.user.uid !== undefined && this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin))
            menu.push({ id: 'partners', path: '/', icon: 'fas fa-archway', name: "Kumppanit", click:this.setView })
          //if(this.user.uid !== undefined && this.staff[this.user.uid] !== undefined &&  this.staff[this.user.uid].allFilesAccess)
          //menu.push({ id: 'files', path: '/', icon: 'fas fa-archive', name: "Tiedostot", click:this.setView })
          if(this.user.uid !== undefined && this.staff[this.user.uid] !== undefined &&  (this.staff[this.user.uid].staffAccess || this.staff[this.user.uid].isAdmin))
            menu.push({ id: 'staff', path: '/', icon: 'fas fa-users', name: "Henkilöstö", click:this.setView })
          //menu.push({ id: 'development', path: '/', icon: 'fas fa-file-code', name: "Kehitys", click:this.setView })
          menu.push({ id: 'signout', path: '/', icon: 'fas fa-sign-out-alt', name: "Logout", click:this.userSignOut })
        }
        else if (this.isWarehouse) {
          menu.push({ id: 'orders', path: '/', icon: 'fas fa-file-invoice-dollar', name: "Tilaukset", click:this.setView, disabled:this.disableOrdersView })
          menu.push({ id: 'stock', path: '/', icon: 'fas fa-warehouse', name: "Varasto", click:this.setView })
          menu.push({ id: 'notes', path: '/', icon: 'fas fa-sticky-note', name: "Informaatio", click:this.setView })
          menu.push({ id: 'products', path: '/', icon: 'fas fa-briefcase', name: "Tuotteet", click:this.setView })
          menu.push({ id: 'partners', path: '/', icon: 'fas fa-archway', name: "Kumppanit", click:this.setView })
          menu.push({ id: 'development', path: '/', icon: 'fa-solid fa-code', name: "Kehitys", click:this.setView })
          menu.push({ id: 'staff', path: '/', icon: 'fas fa-users', name: "Henkilöstö", click:this.setView })
          menu.push({ id: 'signout', path: '/', icon: 'fas fa-sign-out-alt', name: "Logout", click:this.userSignOut })
        }
        return menu
      },

    },
    created () {},
    methods: {
      setView (view) {
          this.drawer = false
          if(view === 'newOrder') this.orderId = null
          this.isWarehouse ? this.warehouseView = view : null
          this.isOffice ? this.officeView = view : null
          this.isSales ? this.salesView = view : null
          this.isAdmin ? this.adminView = view : null
          this.selectedView = view
      },
      userSignOut () {
        this.$store.dispatch('userSignOut')
      },
    }
  }
</script>

<style>
#avecor-toolbar .fa-bars {
    color: #000 !important;
}
.v-toolbar__content {
    padding-right: 0!important;
    padding-left: 5px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/Navigation.vue